export default __webpack_public_path__ + "static/artifakt-legend-medium-d0ec025130fea4ce1b2345e112595b37.svg";